import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Globals } from '../globals';
import { PermisoService } from './permiso.service';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { GeneralService } from './general.service';

@Injectable()
export class KitWebService {
  getkitWeb() {
    throw new Error('Method not implemented.');
  }
    constructor(
        private http: HttpInterceptor,
        // private globals: Globals,
        private general: GeneralService,
        // private permisoService: PermisoService
      ) { }


      getKitWeb(): Observable<any> {
            return this.http
            .post(
              this.general.webserver + 'apiKitBienvenida/ListarKitBienvenida',
              JSON.stringify({
                idCliente: localStorage.getItem('idCliente'),
              })
            )
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
              (respuesta: Response) => respuesta.json()
            );
        }

      crearKitWeb(
        id:any,
        tipo_contacto_estado: any,
        tipo_contacto_desc: any
      ){
        return this.http
            .post(
              this.general.webserver + 'apiKitBienvenida/crearKitBienvenida',
              JSON.stringify({
                idCliente: localStorage.getItem('idCliente'),
                id:id,
                estadoKitBienvenida: tipo_contacto_estado,
                kitBienvenidaNombre: tipo_contacto_desc
              })
            )
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
              (respuesta: Response) => respuesta.json()
            );
      }

      editarKitWeb(
        id:any,
        tipo_contacto_estado: any,
        tipo_contacto_desc: any
      ){
        return this.http
            .post(
              this.general.webserver + 'apiKitBienvenida/actualizarKitBienvenida',
              JSON.stringify({
                idCliente: localStorage.getItem('idCliente'),
                id:id,
                estadoKitBienvenida: tipo_contacto_estado,
                kitBienvenidaNombre: tipo_contacto_desc
              })
            )
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
              (respuesta: Response) => respuesta.json()
            );
      }
}